<template>
  <div v-if="show" class="floating-warning-banner">
    <div class="warning-content">
      <b-icon icon="information" class="warning-icon"></b-icon>
      <div class="warning-text">
        <strong>{{ title }}</strong>
        <p>{{ message }}</p>
      </div>
      <div class="close-button" @click="handleClose">
        <b-icon icon="close" class="close-icon"></b-icon>
      </div>
    </div>
  </div>
</template>

<script>
import BIcon from 'buefy/src/components/icon/Icon';

export default {
  name: 'FloatingWarningBanner',
  components: {
    BIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "We're still processing your request",
    },
    message: {
      type: String,
      default:
        'It may take longer to process. Feel free to leave this page and check back shortly.',
    },
    autoClose: {
      type: Boolean,
      default: false,
    },
    autoCloseDelay: {
      type: Number,
      default: 0, // 0 means no auto-close
    },
  },
  data() {
    return {
      autoCloseTimer: null,
    };
  },
  watch: {
    show(newVal) {
      if (newVal && this.autoClose && this.autoCloseDelay > 0) {
        this.startAutoCloseTimer();
      } else {
        this.clearAutoCloseTimer();
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    startAutoCloseTimer() {
      this.clearAutoCloseTimer();
      this.autoCloseTimer = setTimeout(() => {
        this.handleClose();
      }, this.autoCloseDelay);
    },
    clearAutoCloseTimer() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
    },
  },
  beforeDestroy() {
    this.clearAutoCloseTimer();
  },
};
</script>

<style scoped>
/* Floating warning banner styles */
.floating-warning-banner {
  position: absolute;
  top: 0;
  right: 0;
  max-width: 400px;
  animation: slideInBanner 0.5s ease-out;
  z-index: 10;
}

.warning-content {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  color: #856404;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.warning-icon {
  color: #f39c12;
  font-size: 1.1rem;
  margin-top: 0.125rem;
  flex-shrink: 0;
}

.warning-text {
  flex: 1;
  min-width: 0;
}

.warning-text strong {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
  line-height: 1.2;
}

.warning-text p {
  margin: 0;
  font-size: 0.8rem;
  opacity: 0.9;
  line-height: 1.3;
}

.close-button {
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-top: 0.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  background-color: rgba(133, 100, 4, 0.1);
}

.close-icon {
  color: #856404;
  font-size: 1rem;
  transition: all 0.2s ease;
}

.close-button:hover .close-icon {
  color: #6c5ce7;
}

@keyframes slideInBanner {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
